import { gql } from "@apollo/client";

export default gql`
  mutation EditComment($commentId: ObjectId!, $body: JSON!) {
    editComment(id: $commentId, body: $body) {
      _id
      body
    }
  }
`;
